/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-12-04 16:00:18
 */
import React, { useState, useMemo } from 'react'
import { Button, DatePicker, Form, Row, Select } from 'antd'
import DatesPicker from '../../components/DatesPickerV2'
import DepartmentMemberPicker from '../../components/DepartmentMemberPickerV2'
import sensors from 'sa-sdk-javascript'
import { useAppSelector } from '../../../app/hooks'
import WatermarksPicker from '../../components/WatermarksPicker'
import { shelfApprovalResult } from './lib'
const { Item: FormItem } = Form

const { RangePicker } = DatePicker
const { Option } = Select

export default ({
  filter,
  setFilter,
  onSubmit,
  onReset,
  onReportSaClickEvent,
  isShowShelfVerification
}) => {
  const isStartTimeAfterEndTime = filter.times[0].isAfter(filter.times[1])

  const [showDatePickerPane, setShowDatePickerPane] = useState(false)
  const [showMemberPickerModal, setShowMemberPickerModal] = useState(false)
  const [showWatermarkModal, setShowWatermarkModal] = useState(false)
  const [
    showApprovalUserPickerModal,
    setShowApprovalUserPickerModal
  ] = useState(false)
  const pickerUserCount = useAppSelector(
    (state) => state.organization.pickerOrgUserCount
  )

  const handleDatesChange = (startDate, endDate) => {
    setShowDatePickerPane(false)
    setFilter({ ...filter, times: [startDate, endDate] })
  }

  const handleMemberChangeV2 = (params) => {
    const { selectedDepartmentUsers, selectedDepartments } = params
    setShowMemberPickerModal(false)
    setFilter({
      ...filter,
      departments: selectedDepartments,
      departmentUsers: selectedDepartmentUsers
    })
  }

  const handleApprovalUserChange = (params) => {
    onReportSaClickEvent('chooseApprovalPerson')
    const { selectedDepartmentUsers, selectedDepartments } = params
    setShowApprovalUserPickerModal(false)
    setFilter({
      ...filter,
      approvalDepartments: selectedDepartments,
      approvalUsers: selectedDepartmentUsers
    })
  }

  const handleWatermarksChange = (watermarks) => {
    onReportSaClickEvent('chooseWatermarkName')
    setShowWatermarkModal(false)
    setFilter({ ...filter, watermarks })
  }

  const pickedMembersNum = useMemo(() => {
    const userNumInDepartments = (filter.departments || [])
      .map((department) => department.num)
      .reduce((acc, cur) => acc + cur, 0)
    const total = (filter.departmentUsers || []).length + userNumInDepartments
    const hasSelection =
      (filter.departmentUsers || []).length > 0 ||
      (filter.departments || []).length > 0
    if (
      (!hasSelection && total === 0) ||
      total === pickerUserCount ||
      (filter.departments || []).some((department) => department.id === '0')
    ) {
      return pickerUserCount
    } else {
      return total
    }
  }, [filter, pickerUserCount])

  const pickedApprovalUsersNum = useMemo(() => {
    const userNumInDepartments = (filter.approvalDepartments || [])
      .map((department) => department.num)
      .reduce((acc, cur) => acc + cur, 0)
    const total = (filter.approvalUsers || []).length + userNumInDepartments
    const hasSelection =
      (filter.approvalUsers || []).length > 0 ||
      (filter.approvalDepartments || []).length > 0
    if (
      (!hasSelection && total === 0) ||
      total === pickerUserCount ||
      (filter.approvalDepartments || []).some(
        (department) => department.id === '0'
      )
    ) {
      return pickerUserCount
    } else {
      return total
    }
  }, [filter, pickerUserCount])

  const memberPickerValue = useMemo(() => {
    if (pickedMembersNum === pickerUserCount) {
      return '全部成员'
    }
    return `已选${pickedMembersNum}人`
  }, [pickedMembersNum, pickerUserCount])

  const watermarkPickerValue = useMemo(() => {
    if ((filter.watermarks || []).length === 0) {
      return '全部水印'
    }
    return `${filter.watermarks.length}个水印`
  }, [filter])

  const approvalUserPickerValue = useMemo(() => {
    if (pickedApprovalUsersNum === pickerUserCount) {
      return '全部成员'
    }
    return `已选${pickedApprovalUsersNum}人`
  }, [pickedApprovalUsersNum, pickerUserCount])

  const handleSubmit = () => {
    onReportSaClickEvent('beginSearch')
    onSubmit()
  }

  return (
    <div className="Filter filter-container">
      <div className="visit-record-filter">
        <Form layout="inline">
          <Row>
            <FormItem
              label="筛选时间"
              validateStatus={isStartTimeAfterEndTime ? 'error' : ''}
              help={isStartTimeAfterEndTime ? '结束时间应晚于开始时间' : ''}
            >
              <RangePicker
                value={filter.times}
                open={false}
                allowClear={false}
                onOpenChange={() => {
                  const changedShowDatePickerPane = !showDatePickerPane

                  if (changedShowDatePickerPane) {
                    onReportSaClickEvent('choosePhotoDate')
                    sensors.track('web_workgroup_filter_time_click', {
                      pagePath: window.location.pathname
                    })
                  }

                  setShowDatePickerPane(changedShowDatePickerPane)
                }}
                style={{ width: '236px' }}
              />
            </FormItem>
            <FormItem label="筛选拜访人">
              <Select
                style={{ width: '236px' }}
                value={memberPickerValue}
                open={false}
                onDropdownVisibleChange={() => {
                  setShowDatePickerPane(false)
                  setShowMemberPickerModal(true)
                }}
              ></Select>
            </FormItem>
            <FormItem label="筛选水印">
              <Select
                style={{ width: '236px' }}
                value={watermarkPickerValue}
                open={false}
                onDropdownVisibleChange={() => setShowWatermarkModal(true)}
              ></Select>
            </FormItem>
          </Row>
          {isShowShelfVerification && (
            <Row>
              <FormItem label="审批结果">
                <Select
                  style={{ width: '236px' }}
                  value={filter.approvalStatus}
                  onChange={(value) => {
                    onReportSaClickEvent('chooseApprovalResult')
                    setFilter({ ...filter, approvalStatus: value })
                  }}
                >
                  <Option value={-1}>全部</Option>
                  {shelfApprovalResult.map((item) => {
                    return (
                      <Option value={item.value} key={item.value}>
                        {item.label}
                      </Option>
                    )
                  })}
                </Select>
              </FormItem>
              <FormItem label="审批人">
                <Select
                  style={{ width: '236px' }}
                  value={approvalUserPickerValue}
                  open={false}
                  onDropdownVisibleChange={() =>
                    setShowApprovalUserPickerModal(true)
                  }
                ></Select>
              </FormItem>
            </Row>
          )}

          <Row>
            <FormItem label="" colon={false} style={{ marginLeft: '85px' }}>
              <Button
                disabled={isStartTimeAfterEndTime}
                type="primary"
                style={{ marginRight: '10px' }}
                onClick={handleSubmit}
              >
                开始筛选
              </Button>
              <Button onClick={onReset}>重置</Button>
            </FormItem>
          </Row>
        </Form>
      </div>

      <DatesPicker
        visible={showDatePickerPane}
        dates={filter.times}
        maxMonths={1}
        onChange={handleDatesChange}
        onCancel={() => setShowDatePickerPane(false)}
      />
      <DepartmentMemberPicker
        title="筛选拜访人"
        open={showMemberPickerModal}
        filterObj={filter}
        onOk={handleMemberChangeV2}
        onCancel={() => setShowMemberPickerModal(false)}
      />
      <DepartmentMemberPicker
        title="筛选审批人"
        open={showApprovalUserPickerModal}
        filterObj={{
          departments: filter.approvalDepartments,
          departmentUsers: filter.approvalUsers
        }}
        onOk={handleApprovalUserChange}
        onCancel={() => setShowApprovalUserPickerModal(false)}
      />
      <WatermarksPicker
        visible={showWatermarkModal}
        onOK={handleWatermarksChange}
        onCancel={() => setShowWatermarkModal(false)}
        checkedList={filter.watermarks}
      />
    </div>
  )
}
